import React, { ReactNode } from "react";

import ProfilePicture from "@/components/user/profile-picture";
import { Avatar, Organization } from "@/TS/Interfaces/global_interfaces";

function ProfileEvent({
  firstName,
  lastName,
  avatar,
  jobTitle,
  organization,
  withoutAvatar = false,
}: {
  firstName: string;
  lastName: string;
  avatar?: Avatar;
  jobTitle?: string;
  organization?: Organization | Partial<Organization>;
  withoutAvatar?: boolean;
}): ReactNode {
  return (
    <div className="flex flex-col md:flex-row md:gap-3">
      <ProfilePicture
        className="md:!text-[14px] text-base mx-auto md:mx-0 mb-2 md:mb-0"
        size={32}
        mobileSize={45}
        firstName={firstName}
        lastName={lastName}
        src={avatar?.urls?.avatar_md}
        alt={firstName?.[0] + ". " + lastName}
        withoutAvatar={withoutAvatar}
      />
      <div className="flex leading-5 flex-col text-center md:text-left">
        <p className="font-bold">
          {firstName} {lastName}
        </p>
        <p>{jobTitle}</p>
        <p className="font-bold">{organization?.name}</p>
        <p>{organization?.activity}</p>
      </div>
    </div>
  );
}

export default ProfileEvent;
